module.exports = __webpack_public_path__ + "static/media/logo-twitter-bird-hover.533a58f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-twitter-bird-hover.svg
// module id = 686
// module chunks = 0